// --- Vendors ---
import $ from 'jquery';
import 'foundation-sites';
import GLightbox from 'glightbox';

// --- Components ---
const singleProduct = {
    readyFn: function () {

        console.log("single-product");

        $(document).foundation();

        const lightbox = GLightbox({
            selector: '.glightbox3', // Doit correspondre à la classe ci-dessus
            loop: true,

        });

        const videos = document.querySelectorAll('video.js-lazy-video');

        const loadVideo = (video) => {
            if (video.dataset.loaded) return;

            const src = video.dataset.src;
            if (!src) return;

            const source = document.createElement('source');
            source.src = src;
            source.type = 'video/mp4';
            video.appendChild(source);

            video.load();
            video.dataset.loaded = "1";
        };

        // Lazy load quand visible
        const io = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    loadVideo(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }, { rootMargin: '200px' });

        videos.forEach(video => {
            io.observe(video);

            const wrapper = video.closest('.grid-wrapper');

            if (wrapper) {
                wrapper.addEventListener('mouseenter', () => {
                    loadVideo(video);
                    video.play().catch(() => { });
                });

                wrapper.addEventListener('mouseleave', () => {
                    video.pause();
                    video.currentTime = 0; // optionnel : reset au début
                });
            }
        });

        $(".wrapper-enchantement").on("click", function () {
            $(this).toggleClass("actif");
        });

        $(document).on("click", function () {
            $(".single-enchantement").removeClass("actif");
        });

    }
}
export { singleProduct };